import { centerCrop } from "react-image-crop";

const MAX_OUTPUT_WIDTH = 1200;

/** Crop inițial centrat, fără raport fix — user îl ajustează liber */
export function centerDefaultCrop(mediaWidth, mediaHeight) {
  return centerCrop(
    {
      unit: "%",
      width: 88,
      height: 82,
    },
    mediaWidth,
    mediaHeight
  );
}

export async function cropImageToFile(image, pixelCrop, originalName = "image.jpg") {
  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  const cropX = pixelCrop.x * scaleX;
  const cropY = pixelCrop.y * scaleY;
  let cropW = pixelCrop.width * scaleX;
  let cropH = pixelCrop.height * scaleY;

  if (cropW <= 0 || cropH <= 0) return null;

  let outW = cropW;
  let outH = cropH;

  if (outW > MAX_OUTPUT_WIDTH) {
    const ratio = MAX_OUTPUT_WIDTH / outW;
    outW = MAX_OUTPUT_WIDTH;
    outH = Math.round(outH * ratio);
  }

  canvas.width = Math.round(outW);
  canvas.height = Math.round(outH);

  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  ctx.drawImage(image, cropX, cropY, cropW, cropH, 0, 0, canvas.width, canvas.height);

  const blob = await new Promise((resolve) => {
    canvas.toBlob(resolve, "image/jpeg", 0.92);
  });

  if (!blob) return null;

  const baseName = originalName.replace(/\.[^.]+$/, "") || "image";
  return new File([blob], `${baseName}-cropped.jpg`, { type: "image/jpeg" });
}
